export default __webpack_public_path__ + "static/home.url-797946d44687efab4075e5b573ea73f6.svg";